import { useCallback } from "react";
import {
  useUpsertAssessmentSummaryMutation,
  AssessmentDocument,
  Assessment,
  UpsertAssessmentSummaryMutation,
} from "@/features/assessments/graphql/generated";

export const useAssessmentSummaryUpsert = (
  assessment: Assessment = {} as Assessment
) => {
  const [upsertSummary, { loading }] = useUpsertAssessmentSummaryMutation({
    refetchQueries: [
      { query: AssessmentDocument, variables: { id: assessment.id } },
    ],
  });

  const handleUpsertSummary = useCallback(
    async (summary: string) => {
      const result = await upsertSummary({
        variables: {
          assessmentId: assessment.id!,
          summary,
        },
        optimisticResponse: {
          __typename: "RootMutation",
          upsertAssessmentSummary: {
            ...assessment,
            summary,
          },
        } as unknown as UpsertAssessmentSummaryMutation,
      });

      return result.data?.upsertAssessmentSummary;
    },
    [assessment.id, upsertSummary]
  );

  return { handleUpsertSummary, loading };
};
